import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { SettingsReducer } from "../reducers/SettingReducer";

const SettingsContext = createContext({
	state: SettingsReducer.getInitialState(),
	actions: SettingsReducer.actions,
});

export const useSettingsContext = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: SettingsReducer.getInitialState(),
		reducers: SettingsReducer.caseReducers,
	});

	return (
		<SettingsContext.Provider value={{ state, actions }}>
			{children}
		</SettingsContext.Provider>
	);
};
